// extracted by mini-css-extract-plugin
export default {"timelineAxisHeight":"72","gridRowHeight":"32","currentTimeBar":"current-time-bar_currentTimeBar__CqFbr","topBar":"current-time-bar_topBar__UycvZ"};